import controller from './blog.controller';
import templateBase from './templates/blog-base.view.html';
import templateT1 from './templates/blog-t1.view.html';
import templateAD from './templates/blog.view-adaptative.html';

let BlogComponent = {
    template:changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
    if(__env.adaptative) { return templateAD; }
    else{
        if(response.BLOG !== undefined && response.BLOG.component == 'template_t1'){return templateT1}
        else {return templateBase;}
    }

}

export default BlogComponent;


/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/blog/blog.component.js
 **/